






























































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,LoadDlyComps,GetDlyCompDics,RecordDlyComp,GetDlyComps,DeleteDlyComp} from '../../../api/dialysisProcess'

import {GetListByCode} from '../../../api/configureDictionary/'
import uploadImg from '../../../components/upload/dialysisBeginUploadImg.vue'


@Component({
    components:{
        uploadImg
    }
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    //左右tabs
    tabsShow = 1

    piclist:any = {}
    picConfirm(){
        
    }
    handleVisible:boolean = false
    reasonVisible:boolean = false

    form:any = {
        recipeId:this.data.recipeId,
        recordTime:new Date(),
        complication:null,
        declare:null,
        items:[],
    }
    items:any = {
        reasonType:null,
        reasonDeclare:null,
        handleType:null,
        handleDeclare:null,
        remarks:null,
    }
    reasonTypes:any = []
    handleTypes:any = []
    created() {
        this.getDlyCompDics()
        this.getDlyComps()
    }
    async save(){
        let list = this.reasonOptions.length>=this.handleOptions.length?this.reasonOptions:this.handleOptions
        this.form.items = []
        list.forEach((item:any,index:any) => {
            this.form.items.push({
                reasonType:this.reasonOptions[index]?this.reasonOptions[index].reasonType:null,
                reasonDeclare:this.reasonOptions[index]?this.reasonOptions[index].reasonDeclare:null,
                handleType:this.handleOptions[index]?this.handleOptions[index].handleType:null,
                handleDeclare:this.handleOptions[index]?this.handleOptions[index].handleDeclare:null,
                remarks:null,
            })
        });
        let res = await RecordDlyComp(this.form)
        if(res.status == 1){
            this.$emit('input',false);
            this.$emit('on-back')
        }
    }
    //获取并发症
    async getDlyComps(){
        let data = {
            RecipeId:this.data.recipeId
        }
        let res = await GetDlyComps(data)
        this.compList = res.objects
        this.handleOptions = []
        this.reasonOptions = []
        this.handleTypes = []
        this.reasonTypes = []

    }
    compDicsOptions:any = []
    async getDlyCompDics(){
        let data = {
            Catagroy:1
        }
        let res = await GetDlyCompDics(data)
        this.compDicsOptions = res.objects
        console.log(res)
    }
    handleItems:any = []
    reasonItems:any = []

    handleOptions:any = []
    reasonOptions:any = []

    compDicsChange(){
        this.compDicsOptions.forEach((item:any) => {
            if(this.form.complication == item.complication){
                this.handleItems = item.handleItems
                this.reasonItems = item.reasonItems
            }
        });
    }
    //原因选择
    reasonChange(){
        let oldreasonOptions = this.reasonOptions;
        console.log(this.reasonTypes)
        this.reasonOptions = []
        this.reasonTypes.forEach((element:any) => {
            let oldItem = oldreasonOptions.find((v:any)=>{return v.reasonType==element});
            console.log(oldItem)
            this.reasonOptions.push({
                reasonType:element,
                reasone:this.reasonItems.find((v:any)=>{return v.reasonType==element}).reason,
                handle:null,
                reasonDeclare:oldItem?oldItem.reasonDeclare:'',
                handleType:null,
                handleDeclare:null,
                remarks:null,
            })
        });
        
    }
    //处理选择
    handleChange(){
        let oldhandleOptions = this.handleOptions;
        this.handleOptions = []
        this.handleTypes.forEach((element:any) => {
            let oldItem = oldhandleOptions.find((v:any)=>{return v.handleType==element});
            this.handleOptions.push({
                reasonType:null,
                handle:this.handleItems.find((v:any)=>{return v.handleType==element}).handle,
                reasone:null,
                reasonDeclare:null,
                handleType:element,
                handleDeclare:oldItem?oldItem.handleDeclare:'',
                remarks:null,
            })
        });
        
    }


    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    compEdit(row:any){
        this.form = Object.assign({},row)
        this.compDicsChange()
        this.handleOptions = []
        this.reasonOptions = []
        row.items.forEach((item:any)=>{
            if(item.handleType){
                this.handleOptions.push({
                    reasonType:null,
                    handle:this.handleItems.find((v:any)=>{return v.handleType==item.handleType}).handle,
                    reasone:null,
                    reasonDeclare:null,
                    handleType:item.handleType,
                    handleDeclare:item.handleDeclare,
                    remarks:null,
                })
                this.handleTypes.push(item.handleType)
            }
        })
        row.items.forEach((item:any)=>{
            if(item.reasonType){
                this.reasonOptions.push({
                    reasonType:item.reasonType,
                    handle:null,
                    reasone:this.reasonItems.find((v:any)=>{return v.reasonType==item.reasonType}).reason,
                    reasonDeclare:item.handleDeclare,
                    handleType:null,
                    handleDeclare:null,
                    remarks:null,
                })
                this.reasonTypes.push(item.reasonType)
            }
            
        })
    }
    async compDelete(row:any){
        let res = await DeleteDlyComp({Id:row.id})
        if(res.status == 1){
            this.getDlyComps()
        }
    }
    compList:any = []
    compColumn = [
        {
            title:'发生日期',
            key:'recordTime',
        },
        {
            title:'创建人',
            key:'creatorUser',
        },
        {
            title:'并发症',
            key:'complication',
        },
        {
            title:'内容',
            key:'content',
        },
        {
            title:'说明',
            key:'declare',
        },
        {
            title: this.L('Actions'),
            key: 'Actions',
            width: 150,
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.compEdit(params.row)
                            }
                        }
                    }, '编辑'),
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.compDelete(params.row)
                            }
                        }
                    }, '删除'),
                ])
            }
        }
        
    ]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/dialysisSyndrome.vue